import { useGet } from '@/query/fetchHooks';
import { useState, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TrainingContent } from '@/components/LearningPath/Learn/TrainingContent';
import { NavContext } from '@/components/NavContext';

function TrainingPreview() {
  const { trainingId, organisationId } = useParams();
  const [training, setTraining] = useState<any>(null);
  const [teachers, setTeachers] = useState<any>(null);
  const [score, setScore] = useState<any>(50);
  const [myCertificate, setMyCertificate] = useState<any>(null);
  const [persons, setPersons] = useState<any>(null);
  const [institution, setInstitution] = useState<any>(null);
  const { setHeaderDisabled, setLeftSidebar } = useContext(NavContext);

  useEffect(() => {
    setLeftSidebar(true);
    return () => setLeftSidebar(false);
  });

  useEffect(() => {
    setHeaderDisabled(true);
    return () => setHeaderDisabled(false);
  });

  useGet(`/training/${trainingId}`, {
    onSuccess: async (res: any) => {
      setTraining(res?.data || {});
    },
  });

  useGet(`/trainingteachers`, {
    trainingId: trainingId,
    onSuccess: (res: any) => {
      setTeachers(res?.data);
    },
  });

  useGet(`/trainingcontacts`, {
    trainingId: trainingId,
    organisationId: `${organisationId},OR,organisationId=null`,
    contactType: 'person',
    onSuccess: (res: any) => {
      setPersons(res?.data);
    },
  });

  useGet(`/contact/${training?.institutionId}`, {
    enabled: !!training?.institutionId,
    organisationId: `${organisationId},OR,organisationId=null`,
    onSuccess: (res: any) => {
      setInstitution(res?.data);
    },
  });

  if (!training) return null;

  return (
    <div className="mx-auto flex w-full flex-col ">
      <TrainingContent
        training={training}
        trainingId={trainingId}
        teachers={teachers}
        persons={persons}
        institution={institution}
        followTraining={null}
        setScore={setScore}
        score={score}
        setMyCertificate={setMyCertificate}
        myCertificate={myCertificate}
        submitScore={() => {}}
        preview={true}
        auth={null}
        originPath={null}
      />
    </div>
  );
}

export default TrainingPreview;
